import React from 'react';
import XlsMealsImageUploader from 'pages/new-meal-xls/image-uploader';
import { SelectItem } from 'components/base/select/types';
import { BrandOption } from 'utils/types';
import { ImageDataType } from 'contexts/new-meal-xls.context/context';
import BaseMealUploader from './base-meal-uploader';

type UploadXlsMealsType = {
  imageFiles: File[];
  setImageFiles: (arg0: File[]) => void;
  imageData: ImageDataType[];
  setImageData: (item: ImageDataType[]) => void;
  xlsFile: File | null;
  setXlsFile: (item: File | null) => void;
  selectedBrand: BrandOption;
  setSelectedBrand: (arg0: SelectItem) => void;
  meals: any[];
  setMeals: (arg0: any[]) => void;
};

const UploadXlsBaseMeal = ({
  imageFiles,
  setImageFiles,
  imageData,
  setImageData,
  xlsFile,
  setXlsFile,
  meals,
  setMeals
}: UploadXlsMealsType) => {
  const _setImageFiles = (files: Array<File>) => {
    const filenames: Array<string> = [];
    const filesSet: Array<File> = [];
    if (files) {
      files = Array.from(files).filter((file) => meals.some((meal) => meal.Image === file.name));
    }
    for (const file of files) {
      if (!filenames.includes(file.name)) {
        filenames.push(file.name);
        filesSet.push(file);
      }
    }
    setImageFiles(filesSet);
  };

  return (
    <div>
      <div className='mb-6 space-y-2'></div>
      <BaseMealUploader
        title='Add .xlsx file'
        setMeals={setMeals}
        file={xlsFile}
        setFile={setXlsFile}
      />
      <div className='relative mt-6'>
        {!meals?.length ? (
          <div
            title='Please upload a .xlsx file first'
            className='absolute z-[2] top-[1px] left-[1px] right-[1px] bottom-[1px] rounded-md bg-white/70 grayscale cursor-not-allowed'
          />
        ) : null}

        <XlsMealsImageUploader
          files={imageFiles}
          imageData={imageData}
          setImageData={setImageData}
          setFiles={_setImageFiles}
          disabled={!meals?.length}
        />
      </div>
    </div>
  );
};

export default UploadXlsBaseMeal;
